export const errors = {
  BLADEWALLLET_SIGNER_NOT_INIT: "Signer not initialized",
};

export const NATIVE_TOKEN_MULTIPLIER = 100000000;
export const precision = 4;
